import { useEffect } from "react";
import Select from "react-select";
import { GetProductFeature } from "../../store/itemGroupAtom";
import zIndex from "@mui/material/styles/zIndex";

function SalesOrderFilter(props) {
    const {list} = props;
 


  const customOption = list?.map((item) => {
    return { ...item, label: `${item.Filtering_Name}` };
  });

  const customStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: "#f9fafb",
      borderColor: state.isFocused ? "#0000FF" : "#d1d5db",
      boxShadow: state.isFocused ? "0 0 0 1px rgb(235, 238, 243)" : "none",
      height: 42,
      borderRadius: 6,
      paddingLeft: 4,
      paddingRight: 4,
      fontSize: 14,
      width: '250px',
      transition: "all 0.2s ease-in-out",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 8px",
      width: '250px',
    }),
    placeholder: (base) => ({
      ...base,
      color: "#9ca3af",
    }),
    singleValue: (base) => ({
      ...base,
      color: "#111827",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      width: '250px',
      color: state.isFocused ? "#6b7280" : "#9ca3af",
      "&:hover": {
        color: "#6b7280",
      },
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
      // position: 'absolute',  
      // width: '250px',  
    }),
    option: (base, state) => ({
      ...base,
      width: '250px',
     
      backgroundColor: state.isSelected
        ? "#FFFFFF"
        : state.isFocused
        ? "#f3f4f6"
        : "#ffffff",
      color: "#111827",
      padding: "8px 12px",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#f3f4f6",
      },
      transition: "background-color 0.2s ease",
    }),
  };
  
  return (
    <>
      <div className="w-full">
        <Select
          menuPlacement="auto"
          placeholder="--Please select--"
          menuPosition="fixed"
          menuPortalTarget={document.body} 
          onChange={(e) => props?.onFilterSelect(e)}
          options={customOption}
          styles={customStyles}
        />
      </div>
    </>
  );
}

export default SalesOrderFilter;
